
define('text!templates/reporting.html',[],function () { return '<div class="main-content"></div>\n';});

